module.exports = __webpack_public_path__ + "img/51.27e1f8c9.jpg";